import React, { useState , useRef ,useEffect} from "react";

import { ChartNoAxesGantt, ChevronLeft, ChevronRight, Clock, FlameKindling, Grid2x2, List, Newspaper } from "lucide-react";

import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"

const MockTestPaletteLoading =({setQuestionPaperVisible,handleQuestionClick,setCurrentQuestionIndex,SetQuestionVisited,setCurrentQuestionObject,setButtonQuestionObject,questionsArr,setPalletType,palletType,setPalletDirectionTemp,mockTestCard1Object,currentSection,sectionsArr,currentSectionIndex,testDesignValue,palletDirection,palletDirectionTemp,setPalletDirection})=>{
  
  
    const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
     const [isLoaded, setIsLoaded] = useState(false);
     const [hasError, setHasError] = useState(false);
     
        
             const [reloadItems, setReloadItems] = useState(true);
            
                useEffect(()=>{
                    setReloadItems(false); setReloadItems(true);
                    
                },[ ])
   
                  
     return (
       <div style={{ position: "relative",boxShadow:boxShadow,
       overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
        borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                 borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                 borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                 borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                 
       width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
         {!isLoaded && !hasError && (
           <div
            style={
                { 
                 borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                 borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                 borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                 borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                   position: "absolute",
         top: 0,
         left: 0,
         width: `${width}%`,
         aspectRatio: aspectRatio,
         objectFit: "cover",  }}
          className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
           >
             <img
           src={loading_img}
           alt=""
         
          style={
                {
                borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                 borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                 borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                 borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                 
                   position: "absolute",border:border,
         top: 0,
         left: 0,
         width: `${width}%`,padding:"10px",
       
         objectFit: "cover", aspectRatio: aspectRatio,  }}
          className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
         />
           </div>
         )}
         
         <img
   
         
           src={hasError ? fallback_img : src}
           alt=""
           onLoad={() => setIsLoaded(true)}
           onError={() => setHasError(true)}
          style={
                {
                   position: "absolute",
         top: 0,
         left: 0,
         width: `${width}%`,
        
         objectFit: "cover",aspectRatio: aspectRatio  }}
          className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
         />
       
       </div>
     );
   }; return(<>
    { testDesignValue=="pallet"&&palletDirection=="right"?<div></div>:""}
    {testDesignValue=="pallet"?<>
   
      <div   className={testDesignValue=="pallet"&&palletDirection==="left"?"TestInterfaceLeft":testDesignValue=="pallet"&&palletDirection==="right"?"TestInterfaceRight":"" }
      style={{border:"0px solid #ffffff",background:"#ffffff",borderTopLeftRadius:`${mockTestCard1Object?.sidebarBox?.borderRadius?.topLeft?.value}${mockTestCard1Object?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.sidebarBox?.borderRadius?.topRight?.value}${mockTestCard1Object?.sidebarBox?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.sidebarBox?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.sidebarBox?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.sidebarBox?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.sidebarBox?.borderRadius?.bottomRight?.resolution}`,
padding:"0px" ,display:`${testDesignValue=="pallet"&&(palletDirection==="left"||palletDirection==="right")?"block":"none"}`}}>


<div className="palletMockTopV1"style={{ borderTopLeftRadius:`${mockTestCard1Object?.profileBox?.borderRadius?.topLeft?.value}${mockTestCard1Object?.profileBox?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.profileBox?.borderRadius?.topRight?.value}${mockTestCard1Object?.profileBox?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.profileBox?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.profileBox?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.profileBox?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.profileBox?.borderRadius?.bottomRight?.resolution}`,
}}>  
   <div className="text-linetw"  style={{width:"40px",height:"30px"}}>
     </div>
   <div className="mockTestTitleFont text-linetw " style={{fontSize:"15px",padding:"10px",fontWeight:"999",paddingLeft:"20px"
    , borderTopLeftRadius:`${mockTestCard1Object?.profileName?.borderRadius?.topLeft?.value}${mockTestCard1Object?.profileName?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.profileName?.borderRadius?.topRight?.value}${mockTestCard1Object?.profileName?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.profileName?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.profileName?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.profileName?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.profileName?.borderRadius?.bottomRight?.resolution}`,

   }}> </div> </div> 
   
 
  <div className="palletMockTopV1Title" style={{ borderTopLeftRadius:`${mockTestCard1Object?.PaletteBox?.borderRadius?.topLeft?.value}${mockTestCard1Object?.PaletteBox?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.PaletteBox?.borderRadius?.topRight?.value}${mockTestCard1Object?.PaletteBox?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.PaletteBox?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.PaletteBox?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.PaletteBox?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.PaletteBox?.borderRadius?.bottomRight?.resolution}`,
}}>
   <div className="mockTestButtonFont mockTestTitleFont " style={{display:"flex",gap:"10px",justifyContent:"space-between",fontSize:"19px",height:"30px",padding:"5px",fontWeight:"999",}}> 
   
</div></div>
 <div className="palletMockTopV1PalletInfo" >
    <div className=" text-linetw"style={{height:"30px",color:"#333"}}> 
         <div className="palletInfoTitle mockTestTagsFont" ></div> 
    </div> <div className=" text-linetw"style={{height:"30px",color:"#333"}}> 
         <div className="palletInfoTitle mockTestTagsFont" ></div> 
    </div> <div className=" text-linetw"style={{height:"30px",color:"#333"}}> 
         <div className="palletInfoTitle mockTestTagsFont" ></div> 
    </div>
  </div><div className="palletMockTopV1PalletInfoTwo">
  
  </div>
  <div className="palletMockTopV1PalletBox" style={{margin:"5px",borderTopLeftRadius:`${mockTestCard1Object?.gridListBtnBox?.borderRadius?.topLeft?.value}${mockTestCard1Object?.gridListBtnBox?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.gridListBtnBox?.borderRadius?.topRight?.value}${mockTestCard1Object?.gridListBtnBox?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.gridListBtnBox?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.gridListBtnBox?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.gridListBtnBox?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.gridListBtnBox?.borderRadius?.bottomRight?.resolution}`,
}}>
   
  <div className="palletGridListTitle text-linetw"style={{height:"30px",width:"100px"}}></div>  
   
   
        <div className="palletGridList text-linetw"style={{height:"30px",margin:"10px",
         borderTopLeftRadius:`${mockTestCard1Object?.gridListBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.gridListBtn?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.gridListBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.gridListBtn?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.gridListBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.gridListBtn?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.gridListBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.gridListBtn?.borderRadius?.bottomRight?.resolution}`,

        }}>
                 <Grid2x2 style={{position:"relative"}}   color={"#ffffff"} size={25}/> <div className="mockTestTagsFont"
                 ></div></div> 
      <div className="palletGridList text-linetw"style={{height:"30px",margin:"10px",
         borderTopLeftRadius:`${mockTestCard1Object?.gridListBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.gridListBtn?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.gridListBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.gridListBtn?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.gridListBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.gridListBtn?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.gridListBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.gridListBtn?.borderRadius?.bottomRight?.resolution}`,

        }}>
                 <List style={{position:"relative"}}   color={"#ffffff"} size={25}/> <div className="mockTestTagsFont"
                 ></div></div> </div>

<div className="palletAllButtonsBoxOuter" style={{borderTopLeftRadius:`${mockTestCard1Object?.buttonBox?.borderRadius?.topLeft?.value}${mockTestCard1Object?.buttonBox?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.buttonBox?.borderRadius?.topRight?.value}${mockTestCard1Object?.buttonBox?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.buttonBox?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.buttonBox?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.buttonBox?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.buttonBox?.borderRadius?.bottomRight?.resolution}`,
}}>
  <div className="palletAllButtonsBox">
   <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> <div className="palletNotAttempdedButton mockTestTagsFont"   
     style={{border:"0px solid #ffffff",background:"#f1f1f1"}}
     ></div> 
     </div>
 </div>

<div className="instructionQPOuterGridT1   " >
 <div  className="hideXsForMock text-linetw" style={{height:"40px",width:"150px",display:"flex",justifyContent:"center",alignItems:"center",margin:"5px",margin:"10px",fontWeight:"999",fontSize:"13px"
, borderTopLeftRadius:`${mockTestCard1Object?.qPaperBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.qPaperBtn?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.qPaperBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.qPaperBtn?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.qPaperBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.qPaperBtn?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.qPaperBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.qPaperBtn?.borderRadius?.bottomRight?.resolution}`,
}}><div   className="palletGridList" ></div>
<div className="mockTestButtonFont text-linetw" style={{color:`${mockTestCard1Object?.qPaperBtn?.textColor?.color}`}}></div></div>
<div className="hideXsForMock text-linetw" style={{height:"40px",width:"150px",display:"flex",justifyContent:"center",alignItems:"center",margin:"10px",fontWeight:"999",fontSize:"13px"
 , borderTopLeftRadius:`${mockTestCard1Object?.instructionBtn?.borderRadius?.topLeft?.value}${mockTestCard1Object?.instructionBtn?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.instructionBtn?.borderRadius?.topRight?.value}${mockTestCard1Object?.instructionBtn?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.instructionBtn?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.instructionBtn?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.instructionBtn?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.instructionBtn?.borderRadius?.bottomRight?.resolution}`,

}}><div   className="palletGridList" style={{}}></div><div className="mockTestButtonFont" style={{color:`${mockTestCard1Object?.instructionBtn?.textColor?.color}`}}></div></div></div>

      </div></>:""}</>)
}
export default MockTestPaletteLoading;